<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm06_list"><a id="page_ix"></a>List of Illustrations</h2>
<p class="list"><a class="nounder" href="#/xhtml/ch00_fm07_intro#fig1">1. Liberty tree, James Pike’s powderhorn, 1776</a></p>
<p class="list"><a class="nounder" href="#/xhtml/ch01#fig2">2. <em>Pat Lyon at the Forge</em>, oil painting by John Neagle, 1827</a></p>
<p class="list"><a class="nounder" href="#/xhtml/ch01#fig3">3. Poor Richard Illustrated, engraving, c.1796</a></p>
<p class="list"><a class="nounder" href="#/xhtml/ch01#fig4">4. General Society of Mechanics and Tradesmen of New York certificate</a></p>
<p class="list"><a class="nounder" href="#/xhtml/ch01#fig5">5. Society of Master Sailmakers certificate</a></p>
<p class="list"><span class="nounder" href="#/xhtml/ch02#fig6" title="Link target outside of Sample">6. The death of Christopher Seider, broadside, 1770</span></p>
<p class="list"><span class="nounder" href="#/xhtml/ch03#fig7" title="Link target outside of Sample">7. “A New Method of Macarony Making,” engraving, 1774</span></p>
<p class="list"><span class="nounder" href="#/xhtml/ch03#fig8" title="Link target outside of Sample">8. Oliver Cromwell, engraving, Nathaneal Low’s <em>Almanack for 1774</em></span></p>
<p class="list"><span class="nounder" href="#/xhtml/ch04#fig9" title="Link target outside of Sample">9. Society of Pewterers of New York, flag, 1788</span></p>
<p class="list1"><span class="nounder" href="#/xhtml/ch04#fig10" title="Link target outside of Sample">10. “Gen. Daniel Shays and Col. Job Shattuck,” engraving, 1787</span></p>
<p class="list1"><span class="nounder" href="#/xhtml/ch05#fig11" title="Link target outside of Sample">11. “The World Turned Upside Down,” engraving, 1783</span></p>
<p class="list1"><span class="nounder" href="#/xhtml/ch06#fig12" title="Link target outside of Sample">12. Thomas Paine, engraving, London, c.1792</span></p>
<p class="list1"><span class="nounder" href="#/xhtml/ch06#fig13" title="Link target outside of Sample">13. “Mad Tom in a Rage,” engraving, c.1800</span></p>
<p class="list1"><span class="nounder" href="#/xhtml/ch07#fig14" title="Link target outside of Sample">14. Map of the Freedom Trail</span></p>
<p class="list1"><span class="nounder" href="#/xhtml/ch08#fig15" title="Link target outside of Sample">15. Liberty tree, engraving by Paul Revere, 1765</span></p>
<p class="list1"><span class="nounder" href="#/xhtml/ch08#fig16" title="Link target outside of Sample">16. “The True-Born Sons of Liberty,” broadside, Boston, 1765</span></p>
<p class="list1"><span class="nounder" href="#/xhtml/ch08#fig17" title="Link target outside of Sample">17. Liberty pole, New York City, engraving by P. E. DuSimitiere, c.1770</span></p>
<p class="list1"><span class="nounder" href="#/xhtml/ch08#fig18" title="Link target outside of Sample">18. “Defence of the Liberty Pole in New York,” by Felix Darley</span><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06_list.vue?ff88145c